module.exports = __webpack_public_path__ + "static/img/Yusen2.03bbd354.png";